$('.quotes').slick({
  infinite: true,
  autoplay: false,
  autoplaySpeed: 6000,
  speed: 800,
  arrows: true,
  slidesToShow: 3,
  adaptiveHeight: true,
  responsive: [
        {
            breakpoint: 1050,
            settings: {
                slidesToShow: 2
            }
        },
       {
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});
$('.slide-component-template--23116149752073__product_slider_with_text_8w3tBR').slick({
      slidesToShow: 4, 
      slidesToScroll: 4,
      autoplay: true,
      dots: false,
      responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
      ]
    });
$('.slide-component-template--23116149752073__product_slider_with_text_bk8YPG').slick({
      slidesToShow: 4, 
      slidesToScroll: 4,
      autoplay: true,
      dots: false,
      responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
      ]
    });
$('.slide-component-template--23116149752073__product_slider_with_text_bVVMb7').slick({
      slidesToShow: 4, 
      slidesToScroll: 4,
      autoplay: true,
      dots: false,
      responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
      ]
    });
$('.collection-section-row').slick({
      slidesToShow: 8, 
      slidesToScroll: 8,
      autoplay: false,
      dots: false,
      responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
      ]
    });